import Bus from "../classes/Bus"
import { Position } from 'reactflow';

export const buses = [
  new Bus({alias:"bus", svgSrc: "/symbol-assets/BusMultinodo.svg", label: "Bus-multinodo", rotable: true}),
  new Bus({
    alias:"bus-mononodo",
    type: "BusMononodo",
    svgSrc: "/symbol-assets/BusMononodo.svg",
    label: "Bus - Mononodo",
    rotable: true,
    handles: [
      {
        id: "target",
        type: "target",
        position: Position.Top
      },
      {
        id: "source",
        type: "source",
        position: Position.Bottom
      }
    ]
  }),
];
